import Vue from "vue";
import toast from "../lib/vue_snackbar";
Vue.use(toast);
